var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.createUser}},[_vm._v("Button")])}
var staticRenderFns = []

export { render, staticRenderFns }